import { useEffect, useRef } from 'react';
import { path } from 'ramda';
import { useComponentSettings, useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { scrollTo, scrollToElement } from '@namespace/helpers';
import { useLocation } from '@namespace/i18n';
import { replaceRouterState } from '@namespace/router';

const PADDING = 10;

export const useScrollToElOnBack = (isLoading) => {
  const hasScrolled = useRef(false);
  const { state } = useLocation();
  const { isDesktop } = useDeviceStore();
  const { scrollToElSelector, scrollToY, scrollToComponentType } = state || {};
  const { type } = useComponentSettings();
  const otherSettings = useOtherSettings();
  const disableScrollToEventOnBack = path(
    ['sports', 'disableScrollToEventOnBack'],
    otherSettings
  );

  useEffect(() => {
    if (
      disableScrollToEventOnBack ||
      isLoading ||
      scrollToElSelector == null ||
      scrollToComponentType !== type ||
      hasScrolled.current
    ) {
      return;
    }

    hasScrolled.current = true;

    const el = document.querySelector(scrollToElSelector);

    if (el) {
      replaceRouterState(null);
      scrollTo({ top: scrollToY, behavior: 'instant' });

      const io = new IntersectionObserver((entries) => {
        const isInView = entries[0].intersectionRatio > 0.1;

        if (!isInView) {
          // todo remove when dynamic HEADER_HEIGHT js variable is implemented
          const padding = isDesktop ? PADDING + 12 : PADDING;
          scrollToElement(el, 'smooth', padding);
        }

        io.unobserve(el);
      });

      io.observe(el);
    }
  }, [
    scrollToElSelector,
    isLoading,
    isDesktop,
    scrollToY,
    type,
    scrollToComponentType,
    disableScrollToEventOnBack
  ]);
};
